<div class="config-type-form-container projectable-form-wrapper"
  (keyup.enter)="save($event)"
  (keyup.escape)="closeModal(false)"
  tabindex="0"
  [class.projectable-form-hidden]="!dataInit"
  >
  <lib-form-header
    [data]="formData"
    [title]="(formData.id ? 'Edit Config Type' : 'Create Config Type')"
    [moreActions]="moreActions"
    [multiActions]="multiActions"
    (actionRequested)="headerActionRequested($event)"
    (multiActionRequested)="multiActionRequested($event)"
    [(formView)]="formView"
    [saveDisabled]="saveDisabled || formPermissionSaveDisabled"
    [saveTooltip]="formPermissionSaveDisabled ? formPermissionSaveTooltip : saveButtonTooltip"
    [class.is-scrolled]="isScrolled"
    [strictReadonlyUi]="useStrictReadonlyForm"
  ></lib-form-header>
  <div class="config-form-container projectable-form-container" #formContainer>
    <div class="projectable-form-main-column form-group-row" [hidden]="formView !== 'simple'">
      <div class="form-group-column three-fifths">
        <lib-form-field-container [title]="'Config Name'" [label]="useStrictReadonlyForm ? '' : 'REQUIRED'">
            <input
              class="form-field-input"
              id="ConfigName"
              type="text"
              maxlength="500"
              placeholder="Name this config"
              [ngClass]="{error: errors['name']}"
              [(ngModel)]="formData.name"
              [disabled]="useStrictReadonlyForm"
              >
        </lib-form-field-container>
        <lib-form-field-container [title]="'Schema'" [label]="useStrictReadonlyForm ? '' : 'REQUIRED'" class="schema-json-editor">
          <lib-json-view [(data)]="formData.schema" [jsonInvalid]="errors['schema']" [readOnly]="useStrictReadonlyForm"></lib-json-view>
        </lib-form-field-container>
        <lib-form-field-toggle [(toggleOn)]="showMore" (toggleOnChange)="showMoreChanged($event)" style="margin: 0px 10px"></lib-form-field-toggle>
        <div [hidden]="!showMore" class="form-group-column">
          @if (!hideTags) {
            <lib-form-field-container
              [title]="'Custom Tags'"
              [label]="'OPTIONAL'"
              class="form-field-advanced"
              >
              <lib-custom-tags [(tags)]="formData.tags" [readOnly]="useStrictReadonlyForm"></lib-custom-tags>
            </lib-form-field-container>
          }
        </div>
      </div>
      @if (showApiCalls) {
        <div class="form-group-column two-fifths">
          <lib-form-field-container
            [title]="'API Calls'"
            [label]="''"
            [headerActions]="apiOptions"
            (actionRequested)="apiActionRequested($event)"
            >
            <div class="form-row">
              <input class="form-field-input" [value]="apiCallURL" readonly/>
              <div class="url-copy icon-copy copy-text" (click)="copyToClipboard(apiCallURL)"></div>
            </div>
            @if (formData) {
              <lib-json-view [(data)]="apiData" [readOnly]="true" [showCopy]="true"></lib-json-view>
            }
          </lib-form-field-container>
        </div>
      }
    </div>
    @if (formView === 'raw') {
      <div class="form-group-column">
        @if (formData) {
          <lib-json-view [(data)]="formData" [readOnly]="useStrictReadonlyForm"></lib-json-view>
        }
      </div>
    }
  </div>
</div>
@if (isLoading || !dataInit) {
  <lib-loading-indicator [isLoading]="isLoading || !dataInit"></lib-loading-indicator>
}
